import axios from "axios";
import router from "@/router";

const genres = {
    state: {
        genresList: []
    },
    mutations: {
        setGenresList(state, payload) {
            state.genresList = payload;
        }
    },
    actions: {
        async setGenresList(state) {
            const genresList = await axios.get(router.options.api + '/tags/get-all');
            state.commit('setGenresList', genresList.data);
        },
    },
    getters: {
        getSubjects: state => state.genresList.filter(genre => genre.parent.name.toLowerCase().startsWith('subject')),
        getGenres: state => state.genresList.filter(genre => !genre.parent.name.toLowerCase().startsWith('subject')),
    }
}

export default genres;
